/**
 * homepage-entrance.js — top-level entry attached via Drupal library.
 *
 * Does cheap eligibility checks synchronously, then lazy-loads the heavy
 * orchestrator (three.js + GSAP + DotLottie) in the next idle window.
 * Keeps the LCP budget clean.
 */

function ready() {
  return document.readyState === 'loading'
    ? new Promise(r => document.addEventListener('DOMContentLoaded', r, {once: true}))
    : Promise.resolve();
}

function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function hasWebGL() {
  try {
    const c = document.createElement('canvas');
    return !!(c.getContext('webgl2') || c.getContext('webgl'));
  } catch (e) {
    return false;
  }
}

async function boot() {
  await ready();

  const root = document.querySelector('[data-entrance-root]');
  if (!root) return;

  if (prefersReducedMotion() || !hasWebGL()) {
    root.classList.add('is-fallback');
    return;
  }

  // Branch by viewport. Mobile gets its own portrait orchestrator; the
  // desktop orchestrator stays untouched. Cross-breakpoint reload listeners
  // live inside each orchestrator so a resize across 992px reboots cleanly
  // into the right module.
  const isMobile = window.matchMedia('(max-width: 992px)').matches;

  const runBoot = async () => {
    try {
      if (isMobile) {
        const mod = await import('./homepage-entrance/entrance-mobile.js');
        await mod.initEntranceMobile();
      } else {
        const mod = await import('./homepage-entrance/entrance.js');
        await mod.initEntrance();
      }
    } catch (err) {
      console.warn('[entrance] orchestrator load failed; fallback remains.', err);
      root.classList.add('is-fallback');
    }
  };

  // Lazy-load so it's off the LCP critical path.
  if ('requestIdleCallback' in window) {
    requestIdleCallback(runBoot, {timeout: 2000});
  } else {
    setTimeout(runBoot, 0);
  }
}

boot();

